import { motion } from "framer-motion";
import { Send, MessageCircle, Instagram } from "lucide-react";
import { Reveal } from "./Reveal";

const ATMOSPHERE =
  "https://images.unsplash.com/photo-1714636608872-048fc9231892?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxzb2Z0JTIwbWluaW1hbCUyMHRleHR1cmUlMjBiZWlnZXxlbnwwfHx8fDE3ODc1NzE4NjR8MA&ixlib=rb-4.1.0&q=85";

export const FinalCTA = () => (
  <section id="booking" data-testid="final-cta-section" className="relative overflow-hidden">
    <motion.div
      initial={{ scale: 1.08 }}
      whileInView={{ scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
      className="absolute inset-0"
    >
      <img
        src={ATMOSPHERE}
        alt="Мягкий природный свет"
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-ivory/70" />
    </motion.div>

    <div className="relative mx-auto max-w-[1100px] px-6 py-32 text-center md:px-10 md:py-48">
      <Reveal>
        <img
          src="/logo.png"
          alt="Olga Scherbich — Human Design | Personal Guide"
          data-testid="final-cta-logo"
          className="mx-auto mb-12 w-36 mix-blend-multiply md:w-44"
        />
      </Reveal>
      <Reveal>
        <h2 className="mx-auto max-w-4xl font-serif text-[1.8rem] leading-[1.15] tracking-tight text-charcoal sm:text-[2.4rem] md:text-[3rem]">
          Возможно, Ваш путь не нужно искать.
          <br />
          Возможно, его нужно увидеть.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mx-auto mt-10 max-w-xl font-sans text-[1.15rem] font-light leading-relaxed text-charcoal/75">
          Если Вам хочется лучше понять себя и найти свой внутренний ориентир,
          я буду рада провести для Вас индивидуальное чтение.
        </p>
      </Reveal>
      <Reveal delay={0.18}>
        <a
          href="https://wa.me/971521879400"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-cta-primary"
          className="mt-12 inline-block bg-charcoal px-10 py-4 font-sans text-sm text-ivory transition-colors duration-300 hover:bg-sage"
        >
          Записаться на консультацию
        </a>
      </Reveal>
      <Reveal delay={0.24}>
        <div className="mt-10 flex items-center justify-center gap-6">
          <a
            href="https://t.me/olga_shcherbich"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-telegram"
            className="group inline-flex items-center gap-2 font-sans text-sm text-charcoal/70 transition-colors hover:text-charcoal"
          >
            <Send className="h-4 w-4 text-sage transition-transform group-hover:-translate-y-0.5" strokeWidth={1.5} />
            Telegram
          </a>
          <span className="h-4 w-px bg-charcoal/20" />
          <a
            href="https://wa.me/971521879400"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-whatsapp"
            className="group inline-flex items-center gap-2 font-sans text-sm text-charcoal/70 transition-colors hover:text-charcoal"
          >
            <MessageCircle className="h-4 w-4 text-sage transition-transform group-hover:-translate-y-0.5" strokeWidth={1.5} />
            WhatsApp
          </a>
          <span className="h-4 w-px bg-charcoal/20" />
          <a
            href="https://instagram.com/oscherbich"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-instagram"
            className="group inline-flex items-center gap-2 font-sans text-sm text-charcoal/70 transition-colors hover:text-charcoal"
          >
            <Instagram className="h-4 w-4 text-sage transition-transform group-hover:-translate-y-0.5" strokeWidth={1.5} />
            Instagram
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-charcoal py-16 text-ivory md:py-20">
    <div className="mx-auto flex max-w-[1240px] flex-col items-start justify-between gap-10 px-6 md:flex-row md:items-end md:px-10">
      <div>
        <img
          src="/logo-dark.png"
          alt="Olga Scherbich — Human Design | Personal Guide"
          data-testid="footer-logo"
          className="mb-8 w-24"
        />
        <p className="font-serif text-3xl tracking-tight md:text-4xl">Ольга Щербич | Human Design</p>
        <p className="mt-4 font-sans text-sm font-light text-ivory/60">
          Индивидуальные чтения Human Design
        </p>
      </div>
      <div className="flex items-center gap-6">
        <a
          href="https://t.me/olga_shcherbich"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-telegram"
          className="font-sans text-sm text-ivory/70 transition-colors hover:text-ivory"
        >
          Telegram
        </a>
        <span className="h-4 w-px bg-ivory/25" />
        <a
          href="https://wa.me/971521879400"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp"
          className="font-sans text-sm text-ivory/70 transition-colors hover:text-ivory"
        >
          WhatsApp
        </a>
        <span className="h-4 w-px bg-ivory/25" />
        <a
          href="https://instagram.com/oscherbich"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="font-sans text-sm text-ivory/70 transition-colors hover:text-ivory"
        >
          Instagram
        </a>
      </div>
    </div>
  </footer>
);
